import React, { createContext, useContext, useState, useCallback } from "react";

const ToolModalContext = createContext(null);

export function ToolModalProvider({ children }) {
  const [isOpen, setIsOpen] = useState(false);
  const [activeToolId, setActiveToolId] = useState(null);
  const [toolProps, setToolProps] = useState({});

  const openTool = useCallback((toolId, props = {}) => {
    setActiveToolId(toolId);
    setToolProps(props);
    setIsOpen(true);
  }, []);

  const closeTool = useCallback(() => {
    setIsOpen(false);
    setActiveToolId(null);
    setToolProps({});
  }, []);

  return (
    <ToolModalContext.Provider
      value={{
        isOpen,
        activeToolId,
        toolProps,
        openTool,
        closeTool
      }}
    >
      {children}
    </ToolModalContext.Provider>
  );
}

export function useToolModal() {
  const ctx = useContext(ToolModalContext);
  if (!ctx) {
    throw new Error("useToolModal must be used inside ToolModalProvider");
  }
  return ctx;
}
